var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVaguesBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 119.054,
    viewBox: "0 0 1920 119.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 0.293,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54b03a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e44a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vagues-bg-blanc",
    transform: "translate(81.917 13.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_151",
    "data-name": "Trac\\xE9 151",
    d: "M1835.85,94.825S1365.377-29.8,629.811,26.205C21.5,72.523-82.713-13.107-82.713-13.107s.072,2.527,0,13.437,2.929,26.209,3.473,45.878L1835.85,105.1V98.855",
    transform: "translate(0.873)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M1837.964,67.333s-476.88-115.388-1209.173-41.4S-73.426,9.137-73.426,9.137l-2.493,39.849L1837.964,82.595",
    transform: "translate(0 11.154)",
    fill: "#f4c730",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_153",
    "data-name": "Trac\\xE9 153",
    d: "M1835.448,87.91S1371.228-32.895,632.063,28.72-84.477-7.061-84.477-7.061V100.788H1835.448V97.3",
    transform: "translate(2.635 5.157)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaguesBg);
export default __webpack_public_path__ + "static/media/vagues-bg.702d81631d3f54c98ad03820f56b5899.svg";
export { ForwardRef as ReactComponent };